'use client'
import {
  AvatarBadge
} from "./chunk-BVSSY3BL.mjs";
import {
  AvatarGroup
} from "./chunk-A4TTV745.mjs";
import {
  Avatar
} from "./chunk-V7PAE35Z.mjs";
import "./chunk-V2ATFO44.mjs";
import "./chunk-O25PJXSD.mjs";
import {
  useAvatarStyles
} from "./chunk-RD3LQCU3.mjs";
import {
  GenericAvatarIcon
} from "./chunk-CXYPMOCL.mjs";
export {
  Avatar,
  AvatarBadge,
  AvatarGroup,
  GenericAvatarIcon,
  useAvatarStyles
};
//# sourceMappingURL=index.mjs.map